import ProviderCarousel from 'components/carousels/ProviderCarousel';
import Container from 'components/Container/Container';
import { GameCategoryType } from 'generated/graphql';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SWR_CACHE_CONTROL } from 'utils/swrCacheControl';
import BrowsingGamesPage from 'views/games/BrowsingGames';

export const BrowsingGamesByCategory = () => {
  const router = useRouter();
  const categoryTxt = router.query.category?.toString();

  // category is either a GameCategory or a GameTag
  // If category not in GameCategory enum, assume GameTag
  const category =
    GameCategoryType[categoryTxt?.toUpperCase().replace('-', '_') as GameCategoryType];
  const tag = category ? undefined : categoryTxt;

  let title;

  if (categoryTxt === 'originals') {
    title = 'Shuffle Originals - Crypto Dice, Crash, Plinko, Mines & more';
  } else if (categoryTxt === 'live-casino') {
    title = 'Live Casino Games Online - Roulette, Blackjack & more';
  } else if (categoryTxt === 'slots') {
    title = 'Slots Online - Shuffle.com | VIP Crypto Casino';
  } else if (categoryTxt === 'blackjack') {
    title = 'Blackjack Online - Shuffle.com | VIP Crypto Casino';
  } else if (categoryTxt === 'roulette') {
    title = 'Roulette Online - Shuffle.com | VIP Crypto Casino';
  } else if (categoryTxt === 'baccarat') {
    title = 'Live Baccarat Games - Shuffle.com | VIP Crypto Casino';
  } else if (categoryTxt === 'game-shows') {
    title = 'Live Casino Game Shows - Shuffle.com | VIP Crypto Casino';
  } else if (categoryTxt === 'table-games') {
    title = 'Casino Table Games - Shuffle.com | VIP Crypto Casino';
  }

  return (
    <>
      <Head>
        <title>{title || 'Game category - Shuffle.com | VIP Crypto Casino'}</title>
      </Head>
      <BrowsingGamesPage tag={tag} category={category} />

      <Container>
        <ProviderCarousel />
      </Container>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  res,
}: GetServerSidePropsContext) => {
  res.setHeader('Cache-Control', SWR_CACHE_CONTROL.STANDARD);

  return {
    props: {
      casinoLayout: true,
      activityBoard: true,
      ...(locale ? await serverSideTranslations(locale, ['common', 'errors']) : undefined),
    },
  };
};

export default BrowsingGamesByCategory;
